/* eslint-disable no-undef */
export default function(){
    const choice = useCookie("analytics.consent");// schroedinger state : undefined is in between, -1 is revoked, 1 is granted
    const { gtag, grantConsent, revokeConsent } = useGtag();

    return {gtag, grantConsent, revokeConsent, choice};
}